import {fetchRpc} from './../rpcCall/index.js';
import type {GetAccountInfoConfig,AccountInfoParsed,RpcAccountInfoResponse} from './../../interfaces/index.js';
export function getAccountInfoParams(
  mint: string,
  config: GetAccountInfoConfig = { encoding: 'jsonParsed' }
) {
  return [mint, config] as const;
}
export async function getAccountInfo(
  mint: string
): Promise<AccountInfoParsed | null> {
  return fetchRpc(
    'getAccountInfo',
    getAccountInfoParams(mint)
  );
}
export function normalizeRpcAccount(
  pubkey: string,
  response: RpcAccountInfoResponse
) {
  if (!response || !("value" in response)) {
    throw new Error(
      "normalizeRpcAccount expects RpcAccountInfoResponse (response.result)"
    );
  }

  if (!response.value) return null;

  const { encoding, program, parsed, raw, space } =
    normalizeAccountData(response.value.data);

  return {
    pubkey,
    slot: response.context.slot,
    owner: response.value.owner,
    lamports: response.value.lamports,
    executable: response.value.executable,
    rent_epoch: response.value.rentEpoch,
    space,
    encoding,
    program,
    parsed,
    raw,
  };
}

export function isJsonParsedAccount(
  data: unknown
): data is {
  program: string;
  parsed: unknown;
  space: number;
} {
  return (
    typeof data === 'object' &&
    data !== null &&
    'parsed' in data &&
    'program' in data
  );
}
export function normalizeAccountData(data: any) {
  // jsonParsed form
  if (
    typeof data === "object" &&
    data !== null &&
    "parsed" in data &&
    "program" in data
  ) {
    return {
      encoding: "jsonParsed" as const,
      program: data.program ?? null,
      parsed: data.parsed ?? null,
      raw: null,
      space: typeof data.space === "number" ? data.space : null,
    };
  }

  // base64 tuple form: [data, encoding]
  if (Array.isArray(data) && typeof data[0] === "string") {
    return {
      encoding: (data[1] ?? "base64") as string,
      program: null,
      parsed: null,
      raw: data[0],
      space: null,
    };
  }

  // bare base64 string (older / nonstandard nodes)
  if (typeof data === "string") {
    return {
      encoding: "base64",
      program: null,
      parsed: null,
      raw: data,
      space: null,
    };
  }

  throw new Error(
    `Unknown account data format: ${JSON.stringify(data)}`
  );
}
